import { tracked } from '@glimmer/tracking';

import type { SortOrderDirection } from 'webapp-types';
import { OrderDirection } from 'webapp/enums/enums';
import type { SearchProps } from 'webapp/utils/filter';

import FilterSort from 'webapp/models-custom/filter-sort/base';
import type User from 'webapp/models-custom/user';

export default class FilterSortUser extends FilterSort<User> {
	@tracked override sortProp = 'created';
	@tracked override sortOrder: SortOrderDirection = OrderDirection.DESC;

	override searchProps: SearchProps = {
		name: 2,
		email: 1,
	};
}
